<template>
  <section class="track-views-section grey-bg">
    <div class="container">
      <div class="track-views-content">
        <SectionHeader
          title="Track Profile Views"
          :extraClass="['text-left']"
        />
        <a-row :gutter="32" type="flex" align="middle">
          <a-col :lg="12">
            <div class="slider-content">
              <CoolLightBox
                :items="[image]"
                :index="index"
                :effect="'fade'"
                :useZoomBar="true"
                @close="index = null"
              >
              </CoolLightBox>
              <div class="img-wrap with-shadow" @click="index = 0">
                <div class="hover-bg">
                  <div class="hover-text">
                    Click to Zoom
                  </div>
                </div>
                <img :src="image" alt="track views" />
              </div>
            </div>
          </a-col>
          <a-col :lg="12">
            <div class="steps-list">
              <Card
                :item="item"
                v-for="(item, index) in data"
                :key="index"
                :index="index"
              />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import Card from "@/pageComponents/globalUi/cards/steps-card";
export default {
  name: "TrackViews",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    image: {
      type: String,
      default: ""
    }
  },
  components: {
    SectionHeader,
    Card
  },
  data() {
    return {
      index: null
    };
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.track-views-section {
  .track-views-content {
    .slider-content {
      .img-wrap {
        max-width: 800px;
        border-radius: 2px;
        position: relative;
        overflow: hidden;
        cursor: zoom-in;
        @include boxShadow(0, 0px, 20px, 1px, rgba(0, 0, 0, 0.1));
        .hover-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1;
          opacity: 0;
          border-radius: 6px;
          background: rgba(0, 0, 0, 0.4);
          @include customTransition(0.3s, cubic-bezier(0.44, 0.9, 1, 1));
          .hover-text {
            font-family: $content-font;
            font-weight: 600;
            text-align: center;
            color: #ffffff;
            font-size: 28px;
          }
        }
        &:hover {
          .hover-bg {
            opacity: 1;
          }
        }
      }
    }
    .steps-list {
      .steps-card {
        padding-bottom: 60px;
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .track-views-section {
    .track-views-content {
      .ant-row-flex {
        flex-direction: column-reverse;
      }
      .slider-content {
        .img-wrap {
          margin: 80px 0 0;
        }
      }
      .steps-list {
        .steps-card {
          margin-left: 0;
        }
      }
    }
  }
}
@media only screen and (max-width: 475px) {
  .track-views-section {
    .track-views-content {
      .section-header {
        .section-title {
          text-align: center;
        }
      }
      .slider-content {
        .img-wrap {
          margin-top: 20px;
        }
      }
      .steps-list {
        .steps-card {
          padding-bottom: 30px;
        }
      }
    }
  }
}
</style>
